/**
 * Created by Arison on 2019/7/16.
 */
import * as T from '../actions/actionTypes';

const initialState = {
    tabIndex: 0
};

const appState = (state = initialState, action) => {
  switch (action.type) {
    case T.CHANGE_PAY_TAB_SELECT:
      return {
        ...state,
          tabIndex: action.payload
      };
    default:
      return state;
  }
};

export default appState;